const mutations = {
  getPaymentMethods: (state, payment_method) => {
    state.payment_method = payment_method;
  },
  getPaymentMethod: (state, payment_method_id) => {
    state.payment_method_id = payment_method_id;
  },
  getProductLocation: (state, product_location_id) => {
    state.product_location_id = product_location_id;
  },
  getPaymentMethodPopup: (state, payment_method_popup) => {
    state.payment_method_popup = payment_method_popup;
  },
  getProductLocationPopup: (state, product_location_popup) => {
    state.product_location_popup = product_location_popup;
  },
  getAllProductLocation: (state, product_location) => {
    state.product_location = product_location;
  },
  getAllType: (state, all_type) => {
    state.all_type = all_type;
  },
  getAllGroupBy: (state, group_by) => {
    state.group_by = group_by;
  },
  postPaymentMethod: (state, new_payment_method) => {
    state.payment_method.push(new_payment_method);
  },
  putPaymentMethod: (state, payload) => {
    state.payment_method = state.payment_method.map((payment_method) => {
      if (payment_method.payment_method_id === payload.id) {
        return Object.assign({}, payment_method, payload.payment_methodData);
      }
      return payment_method;
    });
  },
  delPaymentMethod(state, id) {
    const index = state.payment_method.findIndex(payment_method => payment_method.payment_method_id == id);
    state.payment_method.splice(index, 1);
  },
};

export default mutations;
